"use client";

import { useState, useEffect } from "react";
import Image from "next/image";

export interface Sponsor {
  id: number;
  name: string;
  link?: string;
  image_name?: string;
}

interface SponsorInfoProps {
  sponsors: Sponsor[];
}

export function SponsorInfo({ sponsors }: SponsorInfoProps) {
  const [shuffledSponsors, setShuffledSponsors] = useState(sponsors);

  useEffect(() => {
    setShuffledSponsors([...sponsors].sort(() => Math.random() - 0.5));
  }, [sponsors]);

  return (
    <div className="gap-4 p-2">
      <h2 className="text-lg font-bold mb-2">Sponsoren</h2>
      <div className="grid grid-cols-2 gap-2">
        {shuffledSponsors.map((sponsor) => (
          <a key={sponsor.id} href={sponsor.link || "#"} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center text-center group">
            {sponsor.image_name ? (
              <div className="relative w-full h-24 mb-2">
                <Image src={`/uploads/sponsor/${sponsor.image_name}`} alt={sponsor.name} fill className="object-contain" sizes="(max-width: 768px) 100vw, 50vw" />
              </div>
            ) : (
              <div className="w-12 h-12 bg-gray-300 rounded-full mb-2 flex items-center justify-center text-xs font-bold text-gray-600">{sponsor.name.charAt(0)}</div>
            )}
          </a>
        ))}
      </div>
    </div>
  );
}
